import { addDays, startOfDay } from "./date-fns";
import type { Time } from "./time";

export function startOfNextDay(time: Time): Date {
	return startOfDay(addDays(time, 1));
}
